import type { OrganizationState } from '../../../types';

// authorize時とtoken exchange時で同じ式を使うことで、OAuth 2.0 (RFC 6749 §4.1.3) の redirect_uri 完全一致要件を満たす
export const buildRedirectUri = () => `${window.location.origin}/callback`;

export const initOrganizationState = (state: OrganizationState | null) => {
  if (state === null) {
    return { organizationId: '', organizationName: '', ssoStatus: null };
  }
  return {
    organizationId: state.organizationId,
    organizationName: state.organizationName,
    ssoStatus: state.ssoStatus,
  };
};
